var map = {
	"./01_get_account_apiRestrictions.json": "Xu0+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BQvj";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/common/api/permission \.json$
// module id = BQvj
// module chunks = 3